export const phoneNormalize = (phone: string) => {
	return phone.replace(/[\s\(\)\-\s]/g, "")
}
